document.addEventListener('DOMContentLoaded', function() {
  // Function to get the current cart details
  function getCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => console.error('Error fetching cart details:', error));
  }

  // Function to clear all items from the cart
  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(error => console.error('Error clearing cart:', error));
  }

  // Function to add a product to the cart
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    }).then(response => response.json())
      .catch(error => console.error('Error adding product to cart:', error));
  }

  // Function to handle the Add to Cart button click
  function handleAddToCartButtonClick(event) {
    event.preventDefault(); // Prevent default form submission

    // Get the variant ID and quantity from the form
    const form = event.target.closest('form');
    const variantId = form.querySelector('input[name="id"]').value;
    const quantity = document.querySelector('input[name="quantity"]').value || 1;

    // Get the vendor of the product being added
    const productVendor =  meta.product.vendor ? meta.product.vendor : '';

    // Check the cart and process the request
    getCart().then(cart => {
      const currentVendor = cart.items.length > 0 ? cart.items[0].vendor : null;

      if (currentVendor && currentVendor !== productVendor) {
        clearCart().then(() => {
          addToCart(variantId, quantity).then(cartResponse => {
            updateCartUI(cartResponse); // Update cart UI without redirection
          });
        });
      } else {
        addToCart(variantId, quantity).then(cartResponse => {
          updateCartUI(cartResponse); // Update cart UI without redirection
        });
      }
    });
  }

  // Function to update the cart UI
  function updateCartUI(cart) {
    // Optionally, update cart information in the UI
    const cartCountElement = document.querySelector('#cart-count');
    const cartTotalElement = document.querySelector('#cart-total');
    
    if (cartCountElement) {
      cartCountElement.textContent = cart.item_count;
    }
    
    if (cartTotalElement) {
      cartTotalElement.textContent = Shopify.formatMoney(cart.total_price, Shopify.money_format);
    }
    
  }

  // Attach the click event handler to all Add to Cart buttons
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', handleAddToCartButtonClick);
  });
});
